module.exports = __webpack_public_path__ + "3e132eac35788c31ef3cb3a368fd5c36.svg";